<ng-container [ngSwitch]="settings.type">
    <serviceos-ng-default *ngSwitchDefault [settings]="settings" [parentSettings]="parentSettings"
        (changeChoiceItemValue)="onChangeChoiceItemValue($event)">
    </serviceos-ng-default>
</ng-container>